import { render, staticRenderFns } from "./warranty-register.vue?vue&type=template&id=4125931e&scoped=true"
import script from "./warranty-register.vue?vue&type=script&lang=js"
export * from "./warranty-register.vue?vue&type=script&lang=js"
import style0 from "./warranty-register.vue?vue&type=style&index=0&id=4125931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125931e",
  null
  
)

export default component.exports